export default __webpack_public_path__ + "static/media/62t.fd0398fe.jpg";